module.exports = __webpack_public_path__ + "img/pc_p3_y7.73968a64.png";